module.exports = __webpack_public_path__ + "static/oasislab-0c1761d16eb9a1c6df1c222841cb8921.png";